import { render, staticRenderFns } from "./ChaoMaiOrderList.vue?vue&type=template&id=3496c120&scoped=true"
import script from "./ChaoMaiOrderList.vue?vue&type=script&lang=js"
export * from "./ChaoMaiOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3496c120",
  null
  
)

export default component.exports